import React from 'react';
import { motion } from 'framer-motion';
import { LEXCE_AVATAR } from '../data/homeScreen';
interface LexceFabProps {
  onOpen: () => void;
  hint: boolean;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function LexceFab({
  onOpen,
  hint
}: LexceFabProps) {
  return <div className="absolute bottom-24 right-4 z-20 flex items-center gap-2" data-id="element-175" data-mp="jy7pv4t09jf">
      {hint && <motion.p initial={{
      opacity: 0,
      x: 8
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.28,
      ease: EASE,
      delay: 0.5
    }} className="rounded-full bg-white px-3 py-1.5 text-[11px] font-semibold text-vin-primary shadow-card" data-id="element-176" data-mp="3ruyewzbxar9b">
          Say “Hey Lexce!”
        </motion.p>}
      <motion.button type="button" onClick={onOpen} aria-label="Open Hey Lexce assistant" whileTap={{
      scale: 0.94
    }} transition={{
      duration: 0.12,
      ease: EASE
    }} className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-fab ring-2 ring-vin-primary/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-177" data-mp="fayqasz9ljta">
        <motion.span className="absolute inset-0 rounded-full bg-vin-tertiary/25" animate={{
        scale: [1, 1.3],
        opacity: [0.5, 0]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeOut'
      }} data-id="element-178" data-mp="oqxz4w51855q" />
        <motion.img src={LEXCE_AVATAR} alt="" animate={{
        y: [0, -3, 0]
      }} transition={{
        duration: 2.6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="relative h-14 w-14 rounded-full object-cover" data-id="element-179" data-mp="12pnykifbqgx9" />
      </motion.button>
    </div>;
}